import React, { useEffect, useState } from "react";

import AcountInfo from "../../components/corporatedashboard/AcountInfo";
import AppointmentTable from "../../components/corporatedashboard/AppointmentTable";
import CorporateHeader from "../../components/corporatedashboard/CorporateHeader";
import Schedule from "../../components/corporatedashboard/Schedule";
import HealthWorkerDashboardSidebar from "../../components/global/HealthWorkerSidebar";
import HealthWorkerID from "../../components/Users/HealthWorkersUsers/healthWorker/HealthWorkerID";
import ScheduleContainer from "../../containers/corporateContainer/ScheduleContainer";
import ActivitiesHealthContainer from "../../containers/healthWorkersContainer/ActivitiesHealthContainer";
import BreakdownContainer from "../../containers/healthWorkersContainer/BreakdownContainer";
import PaymentHealthContainer from "../../containers/paymentHealthContainer/PaymentHealthContainer";
import { useStateProvider } from "../../manager/StateContext";
import { useAuthManager } from "../../manager/useAuthManager";
import withAuth from "../../manager/withAuth";
import BreadCrumb from "../../shared/BreadCrumb";
import Greeting from "../../shared/Greetings";
import StatsCard from "../../services/data/statisticsData";

import { transformBackendData } from "../../utils/helpers";

export const delQuery = (asPath) => {
  return asPath.split("?")[0];
};

const HealthWorkerDashboard = () => {
  const [isOpen, setOpen] = useState(false);
  const [calendarValue, setCalendarValue] = useState([]);
  const { fetchAppointments } = useAuthManager({
    middleware: "auth",
    role: "carer",
    redirectIfAuthenticated: "",
  });

  const [{ user_special_availability, user_appointments, health_worker_detail, contract_summary }, dispatch] =
    useStateProvider();

    // console.log(contract_summary.chart_data, "contract_summary");

  useEffect(() => {
    if (user_special_availability && user_special_availability?.length > 0) {
      const transformedData = transformBackendData(user_special_availability);
      setCalendarValue(transformedData);
    }
  }, [user_special_availability]);

  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if(user_appointments?.length > 0){
      const currentDate = new Date().toISOString().split("T")[0];
      const filtered = user_appointments?.filter(
        (item) => item.date === currentDate
      );
      setFilteredData(filtered);
    }

  }, [user_appointments]);

  useEffect(() => {
    fetchAppointments();
  }, [])
  return (

    <div className="flex sm:justify-between bg-[#fafafa]  font-Montserrat">
      <HealthWorkerDashboardSidebar isOpen={isOpen} setOpen={setOpen} />

      <div className="sm:w-screen sm:space-x-2">
        
        <CorporateHeader isOpen={isOpen} setOpen={setOpen} />
        <BreadCrumb items={[{ label: "Dashboard |", href: "/health-worker-dashboard" }]} />
        <div className="px-8">
          <Greeting name={health_worker_detail?.user_id?.first_name } />
          <p className = "font-Montserrat font-medium text-xs text-textgray py-2">Check the latest updates on your account.</p>
          </div>
        <div className="px-2 md:px-8">
        {
        health_worker_detail?.verify_status === 0 ? (
          <div className="flex justify-center w-full">
            <div className="flex mt-2 items-center w-fit justify-center py-1 px-2  rounded-3xl text-[10px] text-yellow-700 font-bold mr-1 bg-yellow-100">
              <span className="inline-block mr-[2px]" >Your account is currently going through verification</span>
            </div>
          </div>


        ) : null
      }
        <div className="flex flex-col">
             {/* Contract Statistic Cards Section */}
        <StatsCard contractSummary={contract_summary} />
        <div className="grid py-6 lg:py-12 sm:py-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4  sm:px-8 ">
        <HealthWorkerID />
        <div>
        <div className="block">
                <ScheduleContainer
                  calendarValue={calendarValue}
                  appointments={filteredData}
                />
              <div className="mt-4">
                <Schedule data={filteredData} />
              </div>
            </div>
        </div>
        {/* <div><ActivitiesHealthContainer/></div> */}
      </div>
      
        <div className="flex flex-col lg:flex-row gap-6 p-4 sm:p-6 lg:p-8">
          {/* Line Chart Section */}
          <div className=" w-[100%] md:w-full lg:basis-[70%]">
            <div className="rounded-lg md:p-6 lg:p-6 w-full bg-white">
            <BreakdownContainer contract_summary={contract_summary} />
            </div>
          </div>

          {/* Payment Health Section */}
          <div className="w-full lg:basis-[30%] bg-white">
            <PaymentHealthContainer />
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default withAuth(HealthWorkerDashboard);
